
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Navbar from "./Components/Navbar";
import MediaTV from "./Pages/MediaTV";
import Frontpage from "./Pages/Frontpage";
import Homepage from "./Pages/Homepage";
import About from "./Pages/About";
import Poojas from "./Pages/Poojas";
import Festivals from "./Pages/Festivals";
import Gallery from "./Pages/Gallery";
import Contact from "./Pages/Contact";
import Login from "./Pages/Login";
import Dashboard from "./Pages/Dashboard";
import CommitteeMembers from "./Components/CommitteeMembers";
import PhotoGallery from "./Pages/PhotoGallery";
import VideoGallery from "./Pages/VideoGallery";

// Check whether admin details are stored
function ProtectedDashboard() {
  const admin = localStorage.getItem("admin");

  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  return <Dashboard />;
}

// Show the public Navbar only on public pages
function AppLayout() {
  const location = useLocation();

  const hideNavbar =
    location.pathname === "/login" ||
    location.pathname === "/admin" ||
    location.pathname === "/dashboard";

  return (
    <>
      {!hideNavbar && <Navbar />}

      <Routes>
        {/* PUBLIC PAGES */}
        <Route path="/" element={<Frontpage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/poojas" element={<Poojas />} />
        <Route path="/festivals" element={<Festivals />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/committee" element={<CommitteeMembers />} />
        <Route path="/gallery/photos" element={<PhotoGallery />} />
        <Route path="/gallery/videos" element={<VideoGallery />} />
        <Route path="/gallery/media-tv" element={<MediaTV />} />

        {/* ADMIN LOGIN */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Login />} />

        {/* PROTECTED ADMIN DASHBOARD */}
        <Route
          path="/dashboard"
          element={<ProtectedDashboard />}
        />

        {/* DEFAULT */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
    </BrowserRouter>
  );
}

export default App;
